import {BlockEmbed} from './block';
import Link from './../formats/link';
import $script from 'scriptjs';

class InstagramPost extends BlockEmbed {
  static create(value) {
    let node = super.create();
    let url = this.sanitize(value);
    node.dataset.url = url;
  
    if (url.indexOf('instagram.com/p/') === -1) {
      console.error(`Invalid instagram post url: ${url}\nUse https://www.instagram.com/p/B8FPpMtnt01`);
      return node;
    }
    
    this.createPost(node);
    return node;
  }
  
  static value(domNode) {
    return domNode.dataset.url;
  }
  
  static sanitize(url) {
    if (url.indexOf('?') !== -1) {
      url = url.substring(0, url.indexOf('?'));
    }
    return Link.sanitize(url) // eslint-disable-line import/no-named-as-default-member
  }
  
  static createPost(node) {
    const wrapper = document.createElement('blockquote');
    wrapper.classList.add('instagram-media');
    wrapper.setAttribute('data-instgrm-permalink', node.dataset.url);
    wrapper.style.width = '500px';
    node.appendChild(wrapper);
  
    if (!window.instgrm) {
      $script('//instagram.com/embed.js');
    }
  }
  
  attach() {
    super.attach();
    window.instgrm && window.instgrm.Embeds.process();
  }
}
InstagramPost.blotName = 'instagram';
InstagramPost.tagName = 'instagram';

export default InstagramPost;